import { batch, connect } from 'react-redux';

import {
  actions as filterActions,
  selectTotalSelectedFilterOptionsCount,
} from 'src/components/organisms/Filter';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { updateFilters, UpdateFiltersActionType } from 'src/redux/products';
import { AppThunkDispatch } from 'src/redux/store';
import { actions as visibilityTrackingActions } from 'src/redux/visibilityTracking';
import { SlimFilterMenu } from '../components/SlimFilterMenu';
import { selectSelectedSortingOptionInSentenceCase } from '../modules/selectors';
import { actions as filterMenuActions } from '../modules/slice';
import { STICKY_FILTER_MENU_VISIBILITY_NAME } from '../tracking/events';

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onStickyFilterMenuVisible: () =>
    dispatch(
      visibilityTrackingActions.sectionVisible({
        sectionName: STICKY_FILTER_MENU_VISIBILITY_NAME,
      }),
    ),
  openFilterModal: () => dispatch(filterActions.openModal()),
  onResetFilters: () => {
    batch(() => {
      dispatch(filterActions.resetFilters());
      dispatch(filterMenuActions.resetSelectedSortOption());
      dispatch(updateFilters(UpdateFiltersActionType.FILTER));
    });
  },
});

const mapStateToProps = (state: ReduxApplicationState) => ({
  totalSelectedFilterOptionsCount: selectTotalSelectedFilterOptionsCount(state),
  totalProducts: state.products.totalProducts,
  selectedSortOption: selectSelectedSortingOptionInSentenceCase(state),
  pageProductsCount: state.products.productsReturnedCount,
});

export const SlimFilterMenuContainer = connect(mapStateToProps, mapDispatchToProps)(SlimFilterMenu);
